import PropTypes from 'prop-types';
import React, { useMemo, useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import { FooterContext } from 'components/layouts';
import { clearSimulationTunnel, getSimulationTunnel } from 'utils/simulationTunnel';
import PrevButton from './buttons/PrevButton';
import NavButton from './buttons/NavButton';
import NextButton from './buttons/NextButton';

import './FormButtons.scss';

const FormButtons = (props) => {
    // get the footer element on which we'll attach the portal
    const footerElement = useContext(FooterContext);
    // we won't attach the portal directly into it but in a div as children
    const rootElement = useMemo(() => document.createElement('div'), []);

    // append/remove this div on mounting cycles
    useEffect(() => {
        footerElement.appendChild(rootElement);

        return () => {
            footerElement.removeChild(rootElement);
        };
    }, [footerElement]);

    const {
        last,
        showNav,
        showPrev,
        prevButtonComponent: Prev,
        navButtonComponent: Nav,
        nextButtonComponent: Next,
        isHiddenButton,
        ...rest
    } = props;

    const { list, hideBackButton } = props;
    const simulationTunnel = getSimulationTunnel();
    const back = simulationTunnel && simulationTunnel.isFirstPage ? simulationTunnel.recommendationUrl : rest.back;
    const prevButtonContent = simulationTunnel && simulationTunnel.isFirstPage ? 'Retourner sur la préconisation' : rest.prevButtonContent;
    const nextButtonContent = simulationTunnel && simulationTunnel.isLastPage ? 'Continuer la préconisation' : rest.nextButtonContent;
    const handleBackClick = simulationTunnel && simulationTunnel.isFirstPage ? clearSimulationTunnel : rest.onClick;
    const enhancedRest = {
        ...rest,
        back,
        prevButtonContent,
        nextButtonContent,
        disabled: rest.disabled || rest.nextButtonDisabled,
        onClick: handleBackClick,
    };

    // get button elements
    const prevButton = showNav && showPrev && <Prev {...enhancedRest} />;
    const navButton = !simulationTunnel && null !== list && <Nav {...enhancedRest} />;
    const nextButton = !last && showNav && <Next {...enhancedRest} />;

    return createPortal(
        (
            <div className="formButtons">
                {hideBackButton ? null : prevButton}
                {navButton}
                {!isHiddenButton && nextButton}
            </div>
        ),
        rootElement,
    );
};

FormButtons.propTypes = {
    list: PropTypes.string,
    last: PropTypes.bool,
    showNav: PropTypes.bool,
    showPrev: PropTypes.bool,
    prevButtonContent: PropTypes.string,
    prevButtonComponent: PropTypes.func,
    navButtonComponent: PropTypes.func,
    nextButtonComponent: PropTypes.func,
    isHiddenButton: PropTypes.bool,
    hideBackButton: PropTypes.bool,
};

FormButtons.defaultProps = {
    list: '/',
    last: false,
    showNav: true,
    showPrev: true,
    prevButtonContent: 'Retour',
    prevButtonComponent: PrevButton,
    navButtonComponent: NavButton,
    nextButtonComponent: NextButton,
    isHiddenButton: false,
    hideBackButton: false,
};

export default FormButtons;
